import { useSyncExternalStore } from "react";

/** Whether the media query matches, kept up to date when the window changes (rotation, resize). */
const useMatchesMedia = (query: string): boolean =>
    useSyncExternalStore(
        (onChange) => {
            const media = window.matchMedia(query);
            media.addEventListener("change", onChange);
            return () => media.removeEventListener("change", onChange);
        },
        () => window.matchMedia(query).matches,
    );

export default useMatchesMedia;
